import Vue from 'vue';
import nonreactive from '@/lib/nonreactive';
import handleErrors from '@/lib/handleErrors';

const moduleState = {
  station: {},
  geojson: {
    type: 'FeatureCollection',
    features: [],
  },
  currentId: null,
  stationError: null,
  stationAddEditError: null,
};

const getters = {
  stationDetails: (state) => state.station,
  stationDetailsGeojson: (state) => state.geojson,
  getStationError: (state) => state.stationError,
  getStationAddEditError: (state) => state.stationAddEditError,
};

const mutations = {
  saveStationDetails(state, payload) {
    const geojson = {
      type: 'FeatureCollection',
      features: [],
    };

    if (payload.data && payload.data.alt_fuel_station) {
      state.station = nonreactive.frozen(payload.data.alt_fuel_station);

      geojson.features.push({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [state.station.longitude, state.station.latitude],
        },
        properties: {
          id: state.station.id,
          fuel: state.station.fuel_type_code,
        },
      });
    } else {
      state.station = {};
    }

    state.geojson = nonreactive.frozen(geojson);
    state.currentId = payload.id;
  },

  setStationError(state, status) {
    state.stationError = status;
  },

  setStationAddEditError(state, status) {
    state.stationAddEditError = status;
  },
};

const actions = {
  async fetchStationDetails({ commit, state }, id) {
    try {
      if (id === state.currentId) {
        return;
      }

      commit('setLoadingStationDetails', true);
      const response = await Vue.axios.get(`${process.env.VUE_APP_API_URL_ROOT}/v1/${id}.json`, {
        params: {
          api_key: window.afdcStationsOptions.apiKey,
        },
      });
      commit('saveStationDetails', {
        id,
        data: response.data,
      });
      commit('setStationError', null);
    } catch (e) {
      commit('setStationError', handleErrors(e));
    } finally {
      commit('setLoadingStationDetails', false);
    }
  },
};

export default {
  state: moduleState,
  getters,
  mutations,
  actions,
};
